import React from 'react'
import Col from 'react-bootstrap/Col'

interface HeadingInterface {
  title: string,
  headingLevel?: 1|2|3|4|5|6,
  className?: string,
}

/**
 * Create <h{headingLevel}> html tag
 *
 * @param title
 * @param headingLevel
 * @param className
 * @return {JSX.Element}
 *
 * @constructor
 */
export const Heading = ({title, headingLevel, className}: HeadingInterface) => {
  return (
    <>
      {
        (headingLevel === 1 && <h1 className={`title ${className}`}>{title}</h1>) ||
        (headingLevel === 2 && <h2 className={`title ${className}`}>{title}</h2>) ||
        (headingLevel === 3 && <h3 className={`title ${className}`}>{title}</h3>) ||
        (headingLevel === 4 && <h4 className={`title ${className}`}>{title}</h4>) ||
        (headingLevel === 5 && <h5 className={`title ${className}`}>{title}</h5>) ||
        (headingLevel === 6 && <h6 className={`title ${className}`}>{title}</h6>) ||
        (<h1 className={`title ${className}`}>{title}</h1>)
      }
    </>
  )
}

interface TitleInterface extends HeadingInterface {
  headingClassName?: string,
}

/**
 * Create Col block with a <h{headingLevel}> tag inside
 *
 * @param title
 * @param headingLevel
 * @param headingClassName
 *
 * @return {JSX.Element}
 *
 * @constructor
 */
const Title = ({title, headingLevel, headingClassName}: TitleInterface) => {
  return (
    <Col xs={12}>
      <Heading title={title} headingLevel={headingLevel} className={headingClassName} />
    </Col>
  )
}

export default Title
